import Axios from 'axios'

const camera = {
  getCameras() {
    return Axios.get(`api/v1/cameras`)
  },
  getCamera(id) {
    return Axios.get(`api/v1/cameras/` + id)
  },
  deleteCamera(id) {
    return Axios.delete(`api/v1/cameras/` + id)
  },
  createCamera(camera) {
    return Axios.post(`api/v1/cameras`, camera)
  },
  updateCamera(camera) {
    return Axios.put(`api/v1/cameras`, camera)
  }
}

export default camera
